module.exports = __webpack_public_path__ + "static/1.1b24cc09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BSc/1.png
// module id = 819
// module chunks = 93830084423213 241891719824365